export default __webpack_public_path__ + "static/media/iACST_Hero_final.8596556a.png";